import styled from 'styled-components';

export const Container = styled.div`
  font-size: 12px;
  font-style: italic;
  color: #e02041;
  margin-top: 4px;
  transition: all 0.2s ease-in-out;
`;
